import './spinner.css';
import React from 'react';

const Spinner = () => {
  return (
    <div className='loadingio-spinner-double-ring-06ffj4bbadfx'>
      <div className='ldio-bq9h1bvhxtj'>
        <div></div>
        <div></div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

export default Spinner;
